module.exports = __webpack_public_path__ + "static/media/Survey4TEAMOthersSurvey.accf8f65.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video-champion-101/Survey4TEAMOthersSurvey.mp4
// module id = 7011
// module chunks = 2